import React from 'react';
import Header from '../Components/Header/Header';
import Ourteam from '../Components/OurTeam/Ourteam';
import Footer from '../Components/Footer/Footer';

const Team = () => {
  return (
    <div>
        <Header />
        <Ourteam />
        <Footer />
    </div>
  )
}

export default Team
